import { createFileRoute } from '@tanstack/react-router';

import { FailRecordError } from './-components/error/FailRecordError';
import { FailRecord } from './-components/FailRecord';
import { useFailRecord } from './-logic/useFailRecord';
import { FailRecordContext } from './-logic/useFailRecordContext';

export const Route = createFileRoute('/_authed/record/failed')({
  component: FailRecordPage,
  errorComponent: FailRecordError,
});

function FailRecordPage() {
  return (
    <FailRecordContext.Provider value={useFailRecord()}>
      <FailRecord />
    </FailRecordContext.Provider>
  );
}
